<template>
  <div class="tab-body">
    <div class="search">
      <el-row>
        <el-col :span="24" class="box">
          {{ msg }}
        </el-col>
      </el-row>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData"
        stripe
        border
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
        <el-table-column width="45" label="序">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column width="80" label="月份">
          <template slot-scope="scope">
            {{ scope.row.satm }}
          </template>
        </el-table-column>

        <el-table-column width="60" prop="name" label="姓名">
          <template slot-scope="scope">
            <el-tag size="mini" :title="scope.row.dy">{{
              scope.row.name
            }}</el-tag>
          </template></el-table-column
        >
        <el-table-column width="80" prop="name" label="税前合计">
          <template slot-scope="scope">
            <el-tag size="mini" type="success">{{ scope.row.allsal }}</el-tag>
          </template></el-table-column
        >
        <el-table-column width="95" prop="actcq" label="出勤天数"
          ><template slot-scope="scope">
            <el-tag
              type="info"
              size="mini"
              :title="(scope.row.kqrmk ? scope.row.kqrmk : '')"
            >
              {{ scope.row.actcq }} / {{ scope.row.ndcq }}
            </el-tag>
          </template></el-table-column
        >
        <el-table-column width="110" prop="bsal" label="基本工资"
          ><template slot-scope="scope">
            {{ scope.row.bsal }}
          </template></el-table-column
        >
        <el-table-column width="90" prop="kqsal" label="出勤工资"
          ><template slot-scope="scope">
            {{ scope.row.kqsal }}
          </template></el-table-column
        >
        <el-table-column width="90" prop="kou" label="考勤扣款"
          ><template slot-scope="scope">
            <el-tag
              size="mini"
              type="warning"
              :title="
                '迟到' + scope.row.late + '分钟,漏打卡' + scope.row.ndk + '次'
              "
              >{{ scope.row.kou }}</el-tag
            >
          </template></el-table-column
        >
        <el-table-column width="110" prop="yeji1" label="业绩工资"
          ><template slot-scope="scope">
            <el-tag
              size="mini"
              type="info"
              :title="
                (scope.row.yeji1rmk ? scope.row.yeji1rmk : '') +
                ';' +
                (scope.row.yeji2rmk ? scope.row.yeji2rmk : '') +
                ';' +
                (scope.row.yeji3rmk ? scope.row.yeji3rmk : '')
              "
            >
              {{ scope.row.yeji1 + scope.row.yeji2 + scope.row.yeji3 }}
            </el-tag>
          </template></el-table-column
        >
        <el-table-column width="90" prop="jxkh" label="绩效考核"
          ><template slot-scope="scope">
            <el-tag
              size="mini"
              type="info"
              :title="scope.row.jxkhrmk ? scope.row.jxkhrmk : ''"
            >
              {{ scope.row.jxkh }}
            </el-tag></template
          ></el-table-column
        >
        <el-table-column width="90" prop="othsal" label="其他工资"
          ><template slot-scope="scope">
            <el-tag
              size="mini"
              type="info"
              :title="scope.row.othrmk ? scope.row.othrmk : ''"
            >
              {{ scope.row.othsal }}
            </el-tag></template
          ></el-table-column
        >
        <el-table-column width="90" prop="state" label="状态"
          ><template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.state == 6000">复核中</el-tag>
            <el-tag size="mini" v-if="scope.row.state == 6666">待发放</el-tag>
            <el-tag size="mini" v-if="scope.row.state == 8888">已发放</el-tag>
          </template></el-table-column
        >

        <el-table-column width="90" prop="pssb" label="个人社保">
        </el-table-column>
        <el-table-column width="90" prop="dwsb" label="公司社保">
        </el-table-column>
        <el-table-column
          width="110"
          prop="gesui"
          label="个人所得税"
        ></el-table-column>
        <el-table-column
          width="90"
          prop="salary"
          label="税后工资"
        >
         <template slot-scope="scope">
            <el-tag size="mini" type="danger">{{ Math.floor(scope.row.salary)}}</el-tag>
          </template> 
        </el-table-column>
        <el-table-column
          prop="remark"
          label="发工资备注"
          v-if="ygShow"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from "@/api/cw/salary.js";
export default {
  name: "list",
  components: {},
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      msg: "",
      selected2: 0,
      me: {},
      ygShow: false
    };
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams);
      api.list({}, (res) => {
        this.listData = res.data;
        if (!this.listData || this.listData.length == 0) {
          this.$utils.msg.success("该月没有数据");
        }else{
          for (let i = 0; i < this.listData.length; i++) {
          let d = this.listData[i];

          d.allsal = (
            d.bsal * 1 +
            d.kqsal * 1 +
            d.kou * 1 +
            d.yeji1 * 1 +
            d.yeji2 * 1 +
            d.yeji3 * 1 +
            d.jxkh * 1 +
            d.othsal * 1
          ).toFixed(1);

          let v1 = (d.allsal * 1 + d.pssb * 1 + d.gesui * 1).toFixed(1);
          if (!isNaN(v1)) {
            d.salary = v1;
          }
        }
        }
        this.listLoading = false;
      });
    },

    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      let sumVal = 0;
      this.selected2 = 0;

      for (let item of val) {
        this.selected.push(item.id);
        sumVal += item.allsal * 1;
        this.selected2 += item.haskaipao ? 1 : 0;
      }

      if (this.selected.length > 0) {
        this.msg =
          "已选择: " +
          this.selected.length +
          " 位,税前工资合计: " +
          sumVal.toFixed(0) +
          " 元";
      } else {
        this.msg = "";
      }
    },
  },
  mounted() {
    this.me = this.$caches.user.get();
    if (this.me.role == "ad" || this.me.role2 == "mgr") {
      this.ygShow = true;
    }
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>

